import { describe, expect, it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import {
  ATTACHMENT_FIELDS,
  PAYER_ADDRESS_FIELDS,
  SOLD_TO_ADDRESS_FIELDS
} from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages, { type Card } from '..';

describe('Payer Page Template', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const payerPage = pages[0];

  it('has correct route', () => {
    expect(payerPage.route).toBe(PAGE_ROUTES.financial);
  });

  it('contains expected cards', () => {
    expect(Array.isArray(payerPage.cards)).toBe(true);
    expect(payerPage.cards).toHaveLength(4);
  });

  // ------------------ Payer Address Card ------------------
  describe('Payer Address Card', () => {
    const payerCard = payerPage.cards.find(c => c.key === CARD_CATEGORIES.payer) as Card;

    it('has hideSameAs enabled', () => {
      expect(payerCard.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(payerCard.fields?.map(f => f.key)).toEqual([
        PAYER_ADDRESS_FIELDS.address,
        PAYER_ADDRESS_FIELDS.taxNumber1,
        SOLD_TO_ADDRESS_FIELDS.xmlEmail,
        SOLD_TO_ADDRESS_FIELDS.paymentSlipEmail
      ]);
    });
  });

  // ------------------ Financial Attachment Card ------------------
  describe('Financial Attachment Card', () => {
    const attachmentCard = payerPage.cards.find(c => c.key === CARD_CATEGORIES.financialAttachmentCard) as Card;

    it('has correct field', () => {
      expect(attachmentCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.financialCardAttachment);
    });
  });

  // ------------------ Additional Attachment Card ------------------
  describe('Additional Attachment Card', () => {
    const additionalCard = payerPage.cards.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard) as Card;

    it('has correct field', () => {
      expect(additionalCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });
  });

  // ------------------ Privacy Policy Card ------------------
  describe('Privacy Policy Card', () => {
    const privacyCard = payerPage.cards.find(c => c.key === CARD_CATEGORIES.privacyPolicy) as Card;

    it('has no fields', () => {
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});
